// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"a4358e8c","454":"bcf96607"}[chunkId] + ".chunk.js";
};